import { useEffect, useState } from "react";

import AwaitingInventoryTable from "../../components/awaitingInventory/AwaitingInventoryTable";

import { usePageNameContext } from "../../contexts/PageTitleContext";


type DateRangeType = {
  startDate: string | null;
  endDate: string | null;
};

export default function AwaitingInventory() {
  const { setInfo } = usePageNameContext();

  useEffect(() => {
    setInfo({
      name: "Vehicles Awaiting Inventory",
      desc: "View and manage parts, engine export prices and status' here",
    });
  }, []);


  return (
    <>
      <AwaitingInventoryTable />
    </>
  );
}
